import { c as e } from "./index-BpNK5r1N.mjs";
const a = e(
  [
    "inline-flex items-center justify-center align-middle no-underline",
    "select-none appearance-none px-16 py-4",
    "aria-disabled:pointer-events-none aria-disabled:cursor-not-allowed aria-disabled:border-0"
  ],
  {
    variants: {
      fullWidth: {
        true: "w-full",
        false: "w-fit"
      },
      weight: {
        regular: "",
        bold: "!font-bold"
      },
      size: {
        xxlarge: "min-h-64 px-16 typography-subtitle-20-regular rounded-16",
        large: "min-h-52 px-16 typography-subtitle-16-regular rounded-16",
        medium_plus: "min-h-44 px-16 typography-body-14-regular rounded-12",
        medium: "min-h-40 px-16 typography-body-14-regular rounded-12",
        small: "min-h-32  px-8 typography-body-12-regular rounded-10"
      },
      pcSize: {
        xxlarge: "pc:min-h-64 pc:px-16 pc:typography-subtitle-20-regular pc:rounded-16",
        large: "pc:min-h-52 pc:px-16 pc:typography-subtitle-16-regular pc:rounded-16",
        medium_plus: "pc:min-h-44 pc:px-16 pc:typography-body-14-regular pc:rounded-12",
        medium: "pc:min-h-40 pc:px-16 pc:typography-body-14-regular pc:rounded-12",
        small: "pc:min-h-32 pc:px-8 pc:typography-body-12-regular pc:rounded-10"
      },
      isCapsule: {
        true: "!rounded-full",
        false: ""
      },
      disabledType: {
        default: "aria-disabled:bg-interaction-neutral-disable-main aria-disabled:text-static-white",
        accent: "aria-disabled:bg-fill-neutral-weak1 aria-disabled:text-text-neutral-medium"
      },
      theme: {
        filled_primary: [
          "bg-fill-primary-main text-static-white",
          "hover-never:bg-interaction-primary-presshover-strong3 active:bg-interaction-primary-presshover-strong3"
        ],
        filled_secondary: [
          "bg-fill-primary-weak text-text-primary-main",
          "hover-never:bg-interaction-primary-presshover-weak1 active:bg-interaction-primary-presshover-weak1"
        ],
        filled_basic: [
          "bg-static-white text-text-neutral-main",
          "hover-never:bg-interaction-neutral-presshover-weak1 active:bg-interaction-neutral-presshover-weak1"
        ],
        outlined_primary: [
          "border border-line-primary-main bg-static-white text-text-primary-main",
          "hover-never:bg-interaction-primary-presshover-weak1 active:bg-interaction-primary-presshover-weak1"
        ],
        outlined_secondary: [
          "border border-line-neutral-main bg-static-white text-text-neutral-main",
          "hover-never:bg-interaction-neutral-presshover-weak1 active:bg-interaction-neutral-presshover-weak1"
        ],
        outlined_basic: [
          "border border-line-neutral-weak3 bg-static-white text-text-neutral-main",
          "hover-never:bg-interaction-neutral-presshover-weak1 active:bg-interaction-neutral-presshover-weak1"
        ],
        ghost: [
          "bg-transparent text-text-neutral-main",
          "hover-never:bg-interaction-neutral-presshover-weak1 active:bg-interaction-neutral-presshover-weak1",
          "aria-disabled:bg-transparent"
        ],
        transparent: [
          "bg-transparent text-static-white",
          "hover-never:bg-interaction-transparent-presshover-main active:bg-interaction-transparent-presshover-main",
          "aria-disabled:bg-transparent"
        ]
      }
    },
    defaultVariants: {
      fullWidth: !1,
      weight: "bold",
      theme: "filled_primary",
      isCapsule: !1
    },
    compoundVariants: [
      {
        theme: "ghost",
        disabledType: "default",
        class: "aria-disabled:text-interaction-neutral-disable-main"
      },
      {
        theme: "transparent",
        disabledType: "default",
        class: "aria-disabled:text-interaction-transparent-disable-main"
      }
    ]
  }
), t = e("", {
  variants: {
    direction: {
      left: "mr-2",
      right: "ml-2"
    },
    size: {
      xxlarge: "size-22",
      large: "size-18",
      medium_plus: "size-16",
      medium: "size-16",
      small: "size-14"
    },
    pcSize: {
      xxlarge: "pc:size-22",
      large: "pc:size-18",
      medium_plus: "pc:size-16",
      medium: "pc:size-16",
      small: "pc:size-14"
    }
  },
  defaultVariants: {
    direction: "left"
  }
});
export {
  t as a,
  a as r
};
